<div class="field is-horizontal">
  <div class="field-body">
    <div class="field is-expanded is-hidden-widescreen-down"></div>
    <div class="field is-narrow has-addons">
      <div class="control">
        <label class="label">Columns&nbsp;layout</label>
        <div class="select is-fullwidth">
          <select
            name="layouts"
            [disabled]="isLoading"
            [(ngModel)]="activeLayoutName"
            (ngModelChange)="activatePivotTableLayout($event)"
          >
            @for (layoutName of pivotTableLayoutNames; track layoutName) {
              <option [ngValue]="layoutName">
                {{ layoutName }}
              </option>
            }
          </select>
        </div>
      </div>

      <div class="control">
        <label class="label">&nbsp;</label>
        <button type="button" (click)="showSaveLayoutModal()" class="button">
          Add layout
        </button>
      </div>

      <div class="control">
        <label class="label">&nbsp;</label>
        <button
          type="button"
          (click)="showUpdateLayoutModal(activeLayoutName)"
          [disabled]="usingDefaultColumnLayout"
          class="button"
        >
          Update layout
        </button>
      </div>

      <div class="control">
        <label class="label">&nbsp;</label>
        <button
          type="button"
          (click)="showDeleteLayoutModal(activeLayoutName)"
          [disabled]="usingDefaultColumnLayout"
          class="button"
        >
          Delete layout
        </button>
      </div>
    </div>
  </div>
</div>
